import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Testimonialdetails from "./Testimonial-details";
import { Link } from "react-router-dom";
const Testimonialslider = () => {
  var settings = {
    dots: false,
    infinite: true,
    center:true,
    autoplay:true,
    loop: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div className="testimonial-slider">


          <Slider {...settings}>
  {Testimonialdetails.map((testimonial, index) => (
    <Link to="https://www.capterra.com/p/194158/Vendora/" target="_blank" key={index}>
      <div className="testimonials">
        <i className="fa-solid fa-user"></i>
        <h4>{testimonial.name}</h4>
        <h5>{testimonial.designation}</h5>
        <p>"{testimonial.description}"</p>
      </div>
    </Link>
  ))}
</Slider>
      </div>
   
  );
};

export default Testimonialslider;
